import * as React from 'react';
var TEMP_ERROR_STYLES = {
    paddingLeft: 12,
    fontSize: 13,
    display: 'inline-block'
};
/** @hidden */
export var ValidationError = function (props) {
    var validationMessage = props.validationMessage, valid = props.valid;
    if (valid) {
        // For now it looks better to hide the error enterily
        return null;
    }
    return (React.createElement("div", { className: 'k-required', style: TEMP_ERROR_STYLES }, !valid && validationMessage ? validationMessage : ''));
};
//# sourceMappingURL=ValidationError.js.map